/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Content from 'app/components/common/Content.jsx';
import * as _ from 'underscore';
import PostProvider from 'app/redux/Providers/PostProvider.jsx';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';
import PostingTool from 'app/components/PostingTool/PostingTool.jsx';
import { compose } from 'redux';

class Post extends React.Component {
    constructor(props) {
        super(props);

    }

    componentDidMount() {
        // initialize the post validators if they're not already in the queue
        if (!Object.keys(this.props.posts.postValidators).length) {
            this.props.getPostValidators();
        }

    }

    render() {

        return (
            <Content
                contentClass="post-tool"
                main={<PostingTool {...this.props}/>}/>
        );
    }

}

Post.displayName = "Post";

const enhance = compose(
    ComponentWithContext,
    PostProvider
);

export default enhance(Post);
